import { render, staticRenderFns } from "./UsersModal.vue?vue&type=template&id=316a5fbe&"
import script from "./UsersModal.vue?vue&type=script&lang=js&"
export * from "./UsersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports